import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const TabMedecins = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  const medecins = Array.isArray(form.medecins) && form.medecins.length > 0
    ? form.medecins
    : [""];

  const handleChange = (index, value) => {
    const updated = [...medecins];
    updated[index] = value;
    onChange("medecins", updated);
  };

  const handleAdd = () => {
    onChange("medecins", [...medecins, ""]);
  };

  const handleRemove = (index) => {
    if (medecins.length <= 1) return;
    onChange("medecins", medecins.filter((_, i) => i !== index));
  };

  return (
    <div className="dn-fields">
      {medecins.map((medecin, index) => (
        <div key={index} className="dn-field-group">
          <label>
            Nom et prénoms médecin ({index + 1})
            <ConfidenceLabel confidence={gc(`medecins_${index}`)} />
          </label>
          <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            <input
              type="text"
              placeholder={`Médecin ${index + 1}...`}
              value={medecin ?? ""}
              onChange={(e) => handleChange(index, e.target.value)}
              style={{ flex: 1, borderColor: gc(`medecins_${index}`).color || undefined }}
            />
            {medecins.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="om-bloc-btn om-bloc-btn--remove"
                style={{ flexShrink: 0 }}>
                🗑
              </button>
            )}
          </div>
        </div>
      ))}
      <div style={{ marginTop: "0.75rem" }}>
        <button
          type="button"
          onClick={handleAdd}
          className="om-bloc-btn om-bloc-btn--add">
          + Ajouter un médecin
        </button>
      </div>
    </div>
  );
};

export default TabMedecins;